import { Component, Input, ViewEncapsulation } from '@angular/core';

/**
 * Pure style wrapper for Kendo Grid — same pattern as PlusDoctor-v2's own
 * `DataGridComponent`. Project a complete `<kendo-grid>` with all of its real
 * `<kendo-grid-column>` children as-is; this component never touches columns,
 * cell templates, or grid bindings — it only re-skins whatever Kendo grid is
 * placed inside it (rounded corners, header/row/pager styling) via CSS targeting
 * Kendo's own generated classes. Kendo only discovers columns that are direct
 * descendants of `<kendo-grid>`, so never wrap columns in an `<ng-template>`.
 */
@Component({
  selector: 'app-data-grid',
  templateUrl: './data-grid.component.html',
  styleUrls: ['./data-grid.component.css'],
  // Kendo's projected <kendo-grid> content carries the *parent* component's own
  // encapsulation attribute, not this component's — with emulated encapsulation
  // (the Angular default) these styles would silently never match it. None makes
  // them plain global rules (same as PlusDoctor-v2's own DataGridComponent), scoped
  // safely by the .app-data-grid class prefix on every selector below instead.
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class DataGridComponent {
  /** 'muted' for a subtler grey row-hover instead of the default brand-tinted hover. */
  @Input() hoverVariant: 'brand' | 'muted' = 'brand';
}
